<script>
export default {
  props: {
    prependText: {
      type: String,
      required: false,
      default: "",
    },
    appendText: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      hasLength: false,
    };
  },
  mounted() {
    const input = this.$el.querySelector("input,select,textarea");
    if (!input) {
      return;
    }
    input.addEventListener("focus", this.inputFocus);
    input.addEventListener("blur", this.inputBlur);
  },
  beforeUnmount() {
    const input = this.$el.querySelector("input,select,textarea");
    if (!input) {
      return;
    }
    input.removeEventListener("focus", this.inputFocus);
    input.removeEventListener("blur", this.inputBlur);
  },
  methods: {
    inputFocus() {
      this.hasLength = true;
    },
    inputBlur() {
      this.hasLength = false;
    },
    log(a) {
      console.log(`log`, a);
    },
  },
};
</script>

<template>
  <div class="input-group" :class="{ 'has-length': hasLength }">
    <template v-if="prependText || $slots['prepend-slot']">
      <slot v-if="$slots['prepend-slot']" name="prepend-slot" />
      <span class="input-group-text">
        <template v-if="prependText">
          {{ prependText }}
        </template>
      </span>
    </template>
    <slot />
    <template v-if="appendText || $slots['append-slot']">
      <slot v-if="$slots['append-slot']" name="append-slot" />
      <span v-else class="input-group-text">
        <template v-if="appendText">
          {{ appendText }}
        </template>
      </span>
    </template>
  </div>
</template>
